import PropTypes from 'prop-types';
export const InputPropTypes = {
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    disabled: PropTypes.bool,
    defaultValue: PropTypes.string,
    error: PropTypes.bool,
    errorMessage: PropTypes.string,
    placeholder: PropTypes.string,
    withMask: PropTypes.string,
    name: PropTypes.string,
    inputRef: PropTypes.any,
    label: PropTypes.string,
    min: PropTypes.string,
    max: PropTypes.string,
};
export const InputDefaultPropValues = {
    defaultValue: '',
    label: '',
    placeholder: 'DD/MM/YYYY',
    disabled: false,
    min: new Date().getFullYear() - 120,
    max: new Date().getFullYear(),
};
//# sourceMappingURL=date-picker.prop-types.js.map